import { render, staticRenderFns } from "./PointSettingTop.vue?vue&type=template&id=412c31dc&"
import script from "./PointSettingTop.vue?vue&type=script&lang=js&"
export * from "./PointSettingTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports